export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative pt-20 md:pt-24 pb-16 md:pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/30 via-background-50 to-background-50 pointer-events-none"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 text-accent-400 text-xs md:text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              热门吃瓜入口导航
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-100 leading-tight mb-4">
              在线吃瓜<span className="text-primary-400"> · </span>最新吃瓜入口直达平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-400 font-heading font-light mb-6">
              线路一、官方入口、备用网址一站聚合
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              在线吃瓜品牌入口导航页面，汇集91在线吃瓜网、线路一、网站等官方及最新入口地址。
              我们每日监测各线路可用状态，提供备用网址与官方线路，确保用户快速访问在线吃瓜内容。
              无论入口如何变化，收藏本站即可随时获取最新有效通道，访问不迷路。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                <span className="text-xs text-foreground-400">每日更新检测</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-400 text-sm"></i>
                <span className="text-xs text-foreground-400">多线路实时保障</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-links-line text-accent-400 text-sm"></i>
                <span className="text-xs text-foreground-400">安全直达无跳转</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => { e.preventDefault(); scrollTo('#updates'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-rocket-2-line"></i>
                查看最新入口
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); scrollTo('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-200 hover:bg-background-300 text-foreground-200 font-medium text-sm border border-background-400/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览主题索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100 border border-background-300/30">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20illustration%20with%20warm%20amber%20and%20coral%20accents%2C%20geometric%20network%20nodes%20connected%20by%20glowing%20lines%2C%20modern%20cyber%20aesthetic%2C%20mysterious%20atmosphere%2C%20dark%20background%20with%20subtle%20gradient%2C%20cinematic%20lighting%2C%20technology%20and%20information%20flow%20concept%2C%20clean%20minimal%20composition&width=960&height=720&seq=hero-chigua-main&orientation=landscape"
                alt="在线吃瓜入口导航主视觉"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-50/40 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}